export default [
  {
    path: '/doclist/:id',
    name: 'doclist',
    meta: {
      type: 'doclist',
    },
    component: () => import('@/views/doclist/DocumentList.vue'),
    props: true,
  },
];
